import type { CertGenParams } from '@yandex-int/k-common';

interface Props extends CertGenParams {
    slug: 'StudentDiagInf2025' | 'StudentDiagInfSpo2025';
    issue_date?: string;
}

// eslint-disable-next-line complexity
export const StudentDiagInfSpring2025 = ({
    school_name: schoolName,
    first_name: firstName,
    middle_name: middleName,
    last_name: lastName,
    slug,
}: Props) => {
    let image = '';
    let awardDescription = '';

    switch (slug) {
        case 'StudentDiagInf2025':
            image = 'https://avatars.mds.yandex.net/get-schoolbook-images/5623482/f3KU1AJE8MwBzQ9jeHRrS/orig';
            awardDescription = 'за проверку предметных знаний школьников на платформе <br/> Яндекс Учебник';
            break;
        case 'StudentDiagInfSpo2025':
            image = 'https://avatars.mds.yandex.net/get-schoolbook-images/5623482/f3KU1AJE8MwBzQ9jeHRrS/orig';
            awardDescription = 'за проверку предметных знаний студентов на платформе <br/> Яндекс Учебник';
            break;
    }

    return `<!DOCTYPE html>
    <html lang="ru">
        <head>
            <title>Сертификат кадрового резерва</title>
            <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
            <meta name="viewport" content="width=device-width, initial-scale=1.0" />
            <style>
                @font-face {
                    font-family: 'YS Text';
                    src: url('https://yastatic.net/s3/home/fonts/ys/1/text-light.woff2') format('woff2'),
                        url('https://yastatic.net/s3/home/fonts/ys/1/text-light.woff') format('woff');
                    font-weight: 300;
                    font-style: normal;
                }

                @font-face {
                    font-family: 'YS Text';
                    src: url('https://yastatic.net/s3/home/fonts/ys/1/text-regular.woff2') format('woff2'),
                        url('https://yastatic.net/s3/home/fonts/ys/1/text-regular.woff') format('woff');
                    font-weight: 400;
                    font-style: normal;
                }

                @font-face {
                    font-family: 'YS Text';
                    src: url('https://yastatic.net/s3/home/fonts/ys/1/text-medium.woff2') format('woff2'),
                        url('https://yastatic.net/s3/home/fonts/ys/1/text-medium.woff') format('woff');
                    font-weight: 500;
                    font-style: normal;
                }

                @font-face {
                    font-family: 'YS Text';
                    src: url('https://yastatic.net/s3/home/fonts/ys/1/text-bold.woff2') format('woff2'),
                        url('https://yastatic.net/s3/home/fonts/ys/1/text-bold.woff') format('woff');
                    font-weight: bold;
                    font-style: normal;
                }

                @font-face {
                    font-family: 'YS Display';
                    font-weight: bold;
                    font-style: normal;
                    font-stretch: normal;

                    src: url('//yastatic.net/s3/home/fonts/ys/1/display-bold.woff2') format('woff2'),
                        url('//yastatic.net/s3/home/fonts/ys/1/display-bold.woff') format('woff');
                }

                @font-face {
                    font-family: 'YS Display';
                    font-weight: 800;
                    font-style: normal;
                    font-stretch: normal;

                    src: url('//yastatic.net/s3/home/fonts/ys/1/display-heavy.woff2') format('woff2'),
                        url('//yastatic.net/s3/home/fonts/ys/1/display-heavy.woff') format('woff');
                }

                @page {
                    size: 210mm 297mm;
                    margin: 0;
                    padding: 0;
                }

                @media print {
                    html,
                    body {
                        width: 210mm;
                        height: 297mm;

                        box-sizing: border-box;
                    }
                }

                html {
                    position: relative;

                    margin: 0;
                    padding: 0;


                    --text-color: #fff;
                }

                body {
                    margin: 0;

                    color: var(--text-color);

                    font-family: 'YS Text', sans-serif;
                }

                .page {
                    position: relative;

                    overflow: hidden;

                    box-sizing: border-box;

                    width: 210mm;
                    height: 297mm;

                    background: var(--background-color);

                    page-break-after: always;
                }

                .page__background {
                    position: absolute;

                    width: 100%;
                    height: 100%;

                    overflow: hidden;

                    display: flex;

                    z-index: 1;
                }

                .page__content {
                    height: 100%;
                    width: 100%;
                }

                .content {
                    position: relative;
                    box-sizing: border-box;

                    display: flex;

                    z-index: 5;
                }

                .content {
                    display: flex;
                    flex-direction: column;

                    width: calc(210 / 595 * 304mm);

                    margin-left: calc(210 / 595 * 24mm);

                    color: var(--text-color);
                }

                .empty-space {
                    height: 46.5%
                }

                .content_title {
                    font-size: calc(297 / 842 * 48mm);
                    font-weight: 400;
                    line-height: calc(297 / 842 * 52mm);
                }


                .personal-info__school {
                    font-style: normal;
                    font-weight: 400;
                    font-size: 12pt;
                    line-height: 16.8pt;
                    color: #FFFFFF99;
                    height: calc(297 / 842 * 180mm);
                    margin-top: calc(297 / 842 * 8mm);
                }

                .personal-info__name {
                    font-weight: 500;
                    font-size: 28pt;
                    line-height: 30.75pt;
                    margin-bottom: calc(297 / 842 * 34mm);

                }

                 .award-description {
                    font-weight: 400;
                    font-size: 16pt;
                    line-height: 24pt;
                }
            </style>
        </head>
        <body>
            <div class="page">
                <div class="page__background">
                    <img src="${image}" />
                </div>
                <div class="page__content content content__main">
                    <div class="empty-space"></div>
                    <div class="content_title">Благодарность</div>
                        <div class="personal-info__school">получает педагог <br/> ${
                            schoolName ? `${schoolName}` : ''
                        }</div>
                         <div class="personal-info__name">
                            ${lastName ? `${lastName}` : ''}<br />
                            ${firstName ? `${firstName}` : ''}<br />
                            ${middleName ? `${middleName}` : ''}
                        </div>
                        <div class="award-description">${awardDescription}</div>
                    </div>

                </div>
            </div>
        </body>
    </html>
    `;
};
